import { AnalysisDocument } from "src/app/common/models/analysis-document.model";
import { Article } from "src/app/common/models/article.model";
import { MediaItem } from "src/app/common/models/media-item.model";
import { AgencyNews } from "src/app/modules/agency-news/models/agency-news.model";
import { Audio } from "src/app/modules/audio/models/audio.model";
import { AudiovisualMedia } from "src/app/modules/audiovisual-media/models/audiovisual-media.model";
import { InstagramPost } from "src/app/modules/instagram/models/instagram-post.model";
import { aggSegmentsBySpeaker, segmentsToString } from "src/app/modules/speech2text/models/speech-segment.model";
import { Speech2Text } from "src/app/modules/speech2text/models/speech2text.model";
import { stripHtml } from "string-strip-html";

export const removeHtmlTags = (input: string): string => {
  return stripHtml(input).result;
};

const extractAnalysis = (media: AnalysisDocument, result: string): string => {
  if (media.analysis?.userNeedClassifications) {
    result += "\n\nUserNeeds:";
    for (const [key, value] of Object.entries(media.analysis.userNeedClassifications)) {
      if (key !== "NONE") {
        result += `\n - ${key} - ${value.score.toFixed(2)}`;
      }
    }
  }
  return result;
};

const extractTagsAndEntities = (media: MediaItem, result: string): string => {
  if (media.iptcTagRefs.length > 0) {
    result += "\n\nIPTC Tags:";
    for (const tag of media.iptcTagRefs) {
      result += `\n - ${tag.label} - ${tag.addedManually ? "added manually" : tag.score}`;
    }
  }
  if (media.entityRefs.length > 0) {
    result += "\n\nEntities:";
    for (const entity of media.entityRefs) {
      if (entity.principal) {
        result += `\n - ${entity.label} - ${entity.addedManually ? "added manually" : entity.score}`;
      }
    }
  }
  return result;
};

const extractMetaData = (media: AnalysisDocument & MediaItem, result: string): string => {
  result = extractAnalysis(media, result);
  result = extractTagsAndEntities(media, result);
  return result;
};

export const mediaToString = (
  media: Article | Audio | InstagramPost | Speech2Text | AgencyNews | AudiovisualMedia,
  type: "ARTICLE" | "AUDIO" | "INSTAGRAM_POST" | "SPEECH2TEXT" | "AGENCY_NEWS" | "AUDIOVISUAL_MEDIA",
  language?: string,
): string => {
  let result = "";
  switch (type) {
    case "SPEECH2TEXT":
      media = media as Speech2Text;
      result = `"${media.title}\n${segmentsToString(aggSegmentsBySpeaker(media.segments), language)}"`;
      result = extractMetaData(media, result);
      return result;
    case "AUDIOVISUAL_MEDIA":
      media = media as AudiovisualMedia;
      result = `${media.title}\n${segmentsToString(aggSegmentsBySpeaker(media.segments), language)}`;
      result = extractMetaData(media, result);
      return result;
    case "AUDIO":
      media = media as Audio;
      result = `${media.title}\n${segmentsToString(aggSegmentsBySpeaker(media.segments), language)}`;
      return result;
    case "ARTICLE":
      media = media as Article;
      result = removeHtmlTags(`${media.title}\n\n${media.lead}\n\n${media.body}`);
      result = extractMetaData(media, result);
      return result;
    case "AGENCY_NEWS":
      media = media as AgencyNews;
      result = removeHtmlTags(`${media.title}\n\n${media.body}`);
      result = extractMetaData(media, result);
      return result;
    case "INSTAGRAM_POST":
      media = media as InstagramPost;
      if (media.type === "Reel") {
        result = `${media.title}\n${media.body}\n${segmentsToString(aggSegmentsBySpeaker(media.segments), language)}`;
      } else {
        result = `${media.title}\n${media.body}`;
      }
      result = extractMetaData(media, result);
      return result;
    default:
      return "";
  }
};
